import { getIcon } from '@sly/icons/dynamic';
import DynamicEditor from 'sly/hubPage/components/HubDynamicContent/DynamicEditor';
import { DynamicListWithIconsProps } from 'sly/hubPage/components/HubDynamicContent/DynamicListWithIcons/DynamicListWithIcons.types';

export default function DynamicListWithIcons({
  value,
}: DynamicListWithIconsProps) {
  if (!value) {
    return null;
  }
  return (
    <div
      className='w-[calc(100%-2rem)] pt-xs md:w-[var(--col6)] lg:w-[var(--col8)]'
      data-tp-id='gen-div-c6fbe9a2-e7a4-4aeb-a34e-7c5f1dead8f3'
    >
      {value.map(({ icon, value: innerValue }, index) => {
        const Icon = getIcon(icon);
        if (!Icon) {
          console.warn('Icon not found', icon);
          return null;
        }
        return (
          <div
            className='mb-xs grid grid-cols-[1.5rem_calc(100%-1.5rem-1.5rem)] gap-m md:mb-0'
            key={index}
            data-tp-id='gen-div-791caf5e-314b-401b-9689-bea269914f17'
          >
            <Icon />
            <DynamicEditor content={innerValue} />
          </div>
        );
      })}
    </div>
  );
}
